<template>
<div class="animated fadeIn">
  <div v-if="loading">
    <img class="center" style="margin-top: 15rem;" src="img/preloader.gif" />
  </div>
  <div style="margin-top: 15rem;" v-else-if="card406">
    <b-row>
      <b-col>
        <b-card bg-variant="info">
          <img style="margin-bottom: 50px;" src="img/logo.png" width="400" />
          <h3>İlgili mutabakat bulunamadı!</h3>
        </b-card>
      </b-col>
    </b-row>
  </div>
  <div v-else>
    <b-card v-show="usertoken" bg-variant="info">
      <div>
        <h2>{{userinfo}}</h2>
        <b-button size="lg" v-b-modal.modal4 variant="danger">Çıkış</b-button>
      </div>
    </b-card>
    <b-card id="cardbs">
      <img style="margin-bottom: 20px;" src="img/logo.png" height="80" />
      <h4>Konu : <strong>{{data.konu}}</strong></h4>
      <h4>Tarih : <strong>{{data.tarih}}</strong></h4>
      </br>
      <p>Sayın Yetkili,</p>
      <p>04/02/2010 tarihli Resmi Gazete de yayınlanan 496 Sıra No.lu V.U.K Genel Tebliği ile bilanço esasına göre defter tutan mükelleflerin <strong>{{data.bilgiyil}}</strong> yılı aylık dönemler halinde KDV hariç <strong>{{data.bilgifiyat}}</strong>
        TL'yi aşan mal ve hizmet alımlarını BA Formu, mal ve
        hizmet satışlarını ise BS Formu ile ilgili takip eden ayın 1. gününden itibaren son günü akşamına kadar vermekle
        yükümlüdürler denmiştir.</p>
      <p>
        İlgili tebliğe istinaden Maliye Bakanlığı'na bildirimde bulunacağımız fatura adedi ve KDV
        HARİÇ tutar aşağıdaki gibidir.
      </p>
      <h5>HATA VE UNUTMA MÜSTESNADIR.</h5>
      </br>
      <h5>Firma Ünvanı : <strong>{{data.firmaunvan}}</strong></h5>
      <h5>Vergi Kimlik No : <strong>{{data.vergikimlikno}}</strong></h5>
      </br>
      <b-card-group>
        <b-card bg-variant="primary">
          <p class="card-text">{{data.donem}}</p>
          <div slot="header">
            <strong>
              <font size="3" color="#FE9A2E">Dönem</font>
            </strong>
          </div>
        </b-card>
        <b-card bg-variant="primary">
          <p class="card-text">{{data.belgeler.ykbelgesayi}}</p>
          <div slot="header">
            <strong>
              <font size="3" color="#FE9A2E">Yurtiçi Kargo Belge Sayısı</font>
            </strong>
          </div>
        </b-card>
        <b-card bg-variant="primary">
          <p class="card-text">{{data.belgeler.ykkdv}}</p>
          <div slot="header">
            <strong>
              <font size="3" color="#FE9A2E">Yurtiçi Kargo KDV Hariç Tutar</font>
            </strong>
          </div>
        </b-card>
        <b-card bg-variant="primary">
          <div v-if="editable">
            <b-form-input :state="!$v.data.belgeler.firmabelgesayi.$dirty ? null : !$v.data.belgeler.firmabelgesayi.$invalid" v-model.trim="$v.data.belgeler.firmabelgesayi.$model" type="number" placeholder=""></b-form-input>
            <b-form-invalid-feedback>
              <div v-if="!$v.data.belgeler.firmabelgesayi.numeric">Sadece sayı girilmelidir!</div>
            </b-form-invalid-feedback>
          </div>
          <div v-else>
            <p> {{data.belgeler.firmabelgesayi}}</p>
          </div>
          <div slot="header">
            <strong>
              <font size="3" color="#FE9A2E">Firma Belge Sayısı</font>
            </strong>
          </div>
        </b-card>
        <b-card bg-variant="primary">
          <div v-if="editable">
            <b-form-input :state="!$v.data.belgeler.firmakdv.$dirty ? null : !$v.data.belgeler.firmakdv.$invalid" v-model.trim="$v.data.belgeler.firmakdv.$model" type="number" placeholder=""></b-form-input>
            <b-form-invalid-feedback>
              <div v-if="!$v.data.belgeler.firmakdv.numeric">Sadece sayı girilmelidir!</div>
            </b-form-invalid-feedback>
          </div>
          <div v-else>
            <p>{{data.belgeler.firmakdv}}</p>
          </div>
          <div slot="header">
            <strong>
              <font size="3" color="#FE9A2E">Firma KDV Hariç Tutar</font>
            </strong>
          </div>
        </b-card>
      </b-card-group>
      <div v-show="editable">
        <b-button-group>
          <b-button size="lg" :disabled="data.belgeler.firmabelgesayi == '' || data.belgeler.firmakdv == '' || $v.data.$invalid" v-b-modal.modal2 variant="success">Onayla</b-button>
          <b-button size="lg" @click.stop="tableIptal" variant="danger">İptal</b-button>
        </b-button-group>
      </div>
      <p>
        Yukarıdaki bilgilerin doğruluğunu teyit etmenizi rica ederiz.
      </p>
      <p>
        Mutabık değilseniz, Firma Belge Sayısı ve Firma KDV Hariç Tutar alanlarını doldurmanız gerekmektedir.
      </p>
      <p>
        Saygılarımızla,
      </p>
      <h5>İlgili Kişi : <strong>{{data.ilgili}}</strong></h5>
      <b-card bg-variant="light">
        <h5>Sayın YURTİÇİ KARGO SERVİSİ A.Ş.</h5>
        <div v-show="data.mutabakatcevap == 'true'">
          <h5 v-show="data.cevap.status == 'MTB'" style="margin-top: 15px;"> Mutabakat formu {{data.cevap.cevaptarih}} tarihinde, {{data.cevap.cevapsaat}} zamanında onaylandı. ip: {{data.cevap.ip}}</h5>
          <h5 v-show="data.cevap.status == 'MTD'" style="margin-top: 15px;"> Mutabakat formu {{data.cevap.cevaptarih}} tarihinde, {{data.cevap.cevapsaat}} zamanında onaylanmadı. ip: {{data.cevap.ip}}</h5>
        </div>
        <div v-show="data.mutabakatcevap == 'false'">
          <p><strong>{{data.cardyil}}</strong> yılı <strong>{{data.carday}}</strong> ayında firmamıza vermiş olduğunuz hizmet KDV HARİÇ tutarlar ve adetlerde <strong>{{mutabakattext}}</strong> bildiririz.</p>
          <b-button-group v-show="mutabButtonsVisible && !usertoken">
            <b-button size="lg" v-b-modal.modal1 @click.stop="mutabyes" variant="success">Mutabık</b-button>
            <b-button size="lg" @click.stop="mutabno" variant="danger">Mutabık değil</b-button>
          </b-button-group>
          <h5 style="margin-top: 15px;">{{onaytext}}</h5>
        </div>
      </b-card>
      <p>İstek dahilinde ilgili kişiye gönderilmek üzere yorumlarınızı girebilir, dosya ekleyebilirsiniz.</p>
      <b-button size="lg" @click="collapse = !collapse" variant="info">Yorum Ekle</b-button>
      </br>
      <b-collapse v-model="collapse" id="collapse" class="mt-2">
        <b-form-textarea id="textarea1" v-model="messageText" placeholder="Yorumunuzu buraya yazabilirsiniz.." :rows="3" :max-rows="6">
        </b-form-textarea>
        <b-button @click.stop="mesajyolla" variant="success">Gönder</b-button>
      </b-collapse>
      </br>
      <div v-for="item in messages">
        <b-card bg-variant="info">
          <h5><strong>{{item.userinfo}}</strong> yorum ekledi. {{item.time}}</h5>
          <p>{{item.message}}</p>
        </b-card>
      </div>
      <b-button size="lg" @click="collapse2 = !collapse2" variant="info">Dosya Ekle</b-button>
      </br>
      <b-collapse v-model="collapse2" id="collapse" class="mt-2">
        <div class="large-12 medium-12 small-12 cell">
          <h5>Dosya Seç</h5>
          <b-button @click.stop="trigger" variant="outline-info">
            <font-awesome-icon size="5x" icon="file-upload" />
          </b-button>
          <input style="display: none;" type="file" ref="upload" @input="fileHandler"></input>
        </div>
        <div class="large-12 medium-12 small-12 cell">
          <div v-for="(file, key) in selectedFiles" class="file-listing">{{ file.name }} <span class="remove-file" v-on:click="removeFile( key )">Remove</span></div>
        </div>
        <br>
        <div v-show="!selectedFiles.length==0">
          <b-progress :value="percentCompleted" :max="100" class="w-25" show-progress animated></b-progress>
          </br>
          <b-button @click="submitFiles()" variant="info">Yükle</b-button>
        </div>
      </b-collapse>
      </br>
      <b-row>
        <b-col v-for="item in files" lg="2" sm="12">
          <b-card>
            <b-row>
              <i>{{item.userinfo}} tarafından eklendi.</i>
              <i>{{item.time}}</i>
            </b-row>
            <b-button style="margin-top: 1rem;" @click="dosyaDownload(item.dosyaadi)" variant="outline-info">
              <font-awesome-icon size="5x" icon="file-download" />
            </b-button>
            </i>
            <div class="h3 mb-0">{{item.dosyaadi}}</div>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    <div v-show="data.mutabakatcevap == 'false' && !usertoken">
      <b-card v-show="mutabButtonsVisible" bg-variant="danger">
        <h5>Bu mutabakat tarafıma ait değildir!</h5>
        <b-button size="lg" v-b-modal.modal3 variant="info">Onay</b-button>
      </b-card>
    </div>
    <b-modal id="modal1" ref="modal" title="Mutabakat Onay" @ok="mutabOnay">
      <h5>Mutabık olduğumuzu onaylıyoruz.</h5>
    </b-modal>
    <b-modal id="modal2" ref="modal" title="Mutabık Olmama Onay " @ok="mutabOlmamaOnay">
      <h5>Mutabık olmadığımızı onaylıyoruz.</h5>
    </b-modal>
    <b-modal id="modal3" ref="modal" title="Mutabakat Formu" @ok="mutabakatAitDegil">
      <b-list-group>
        <b-list-group-item v-show="!mutabAitDegilCheckbox">
          <h5>Mutabakata cevap vermesi gereken kişi e-mail adresi</h5>
          <b-row class="my-1" v-for="(email, index) in emailFields">
            <b-col sm="2"><label>Mail:</label>
            </b-col>
            <b-col sm="10">
              <b-form inline>
                <b-input-group left="@" class="mb-3 mr-sm-3 mb-sm-0">
                  <b-form-input type="email" v-model="emailFields[index].mailAdress"></b-form-input>
                </b-input-group>
                <button @click="deleteEmailfield" type="button" class="btn btn-pill btn-danger btn-sm"><i class="fa fa-minus"></i></button>
              </b-form>
            </b-col>
          </b-row>
          <button @click="addEmailfield" type="button" class="btn btn-outline-success btn-bg">Email Ekle</i></button>
        </b-list-group-item>
        <b-list-group-item>
          <div style="margin-top: 30px;">
            <h5>Bu mutabakat firmamıza ait değildir!</h5>
            <label class="switch switch-lg switch-3d switch-danger">
              <input v-model="mutabAitDegilCheckbox" type="checkbox" class="switch-input" checked>
              <span class="switch-slider"></span>
            </label>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-modal>
    <b-modal id="modal4" ref="modal" title="Çıkış Onay" @ok="cikisYap">
      <h5>Kullanıcı çıkışı yapmayı onaylıyor musunuz?</h5>
    </b-modal>
  </div>
</div>
</template>

<script>
import axios from 'axios';
var moment = require('moment');
import "url-polyfill";
import {
  email,
  numeric,
  alpha,
  required,
  minLength,
  between,
  sameAs
} from 'vuelidate/lib/validators'
import {
  validationMixin
} from "vuelidate"

const HTTP = axios.create({
  //  baseURL: ‘/’,
  'X-Custom-Header': 'foobar',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer'
  }
});

import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  faFileDownload
} from '@fortawesome/free-solid-svg-icons'
import {
  faFileUpload
} from '@fortawesome/free-solid-svg-icons'

import saveAs from 'file-saver';


library.add(faFileDownload, faFileUpload);

export default {
  components: {

  },
  data() {
    return {
      card406: false,
      mutabAitDegilCheckbox: false,
      mutabCevapVermesiGerekenMail: [],
      emailFields: [{
        mailAdress: ''
      }],
      percentCompleted: 0,
      usertoken: '',
      userinfo: '',
      mutabakattoken: '',
      mutabatAitDegilbutton: true,
      loading: true,
      filename: '',
      ip: '',
      datenow: moment().format('YYYY-M-D'),
      timenow: moment().format('HH:mm'),
      mutabButtonsVisible: true,
      mutabakattext: 'mutabık olduğumuzu / mutabık olmadığımızı',
      editable: false,
      collapse: false,
      collapse2: false,
      onaytext: '',
      messageText: '',
      data: {
        mutabakatcevap: '',
        cevap: {
          status: '',
          cevaptarih: '',
          cevapsaat: '',
          ip: null
        },
        konu: '',
        tarih: '',
        bilgiyil: '',
        bilgifiyat: '',
        firmaunvan: '',
        vergikimlikno: '',
        ilgili: '',
        cardyil: '',
        carday: '',
        donem: '',
        belgeler: {
          firmabelgesayi: '',
          firmakdv: '',
          ykbelgesayi: '',
          ykkdv: '',
        }
      },
      messages: [],
      files: [],
      selectedFiles: [],
      fields: {
        donem: {
          label: 'Dönem',
          sortable: false,
          variant: 'info'
        },
        ykbelgesayi: {
          label: 'Yurtiçi Kargo Belge Sayısı',
          sortable: false,
          variant: 'info'
        },
        ykkdv: {
          label: 'Yurtiçi Kargo KDV Hariç Tutar',
          sortable: false,
          variant: 'info'
        },
        firmabelgesayi: {
          label: 'Firma Belge Sayısı',
          sortable: false,
          variant: 'info'
        },
        firmakdv: {
          label: 'Firma KDV Hariç Tutar',
          sortable: false,
          variant: 'info'
        }
      },
      items: [{
        donem: '',
        ykbelgesayi: '',
        ykkdv: '',
        firmabelgesayi: '',
        firmakdv: '',
      }]
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    data: {
      belgeler: {
        firmabelgesayi: {
          numeric
        },
        firmakdv: {
          numeric
        }
      }
    }
  },
  methods: {
    fileHandler(evt) {
      this.$emit("input", evt.target.files[0]);
      this.selectedFiles.push(evt.target.files[0]);
    },
    trigger() {
      this.$refs.upload.click();
    },
    addEmailfield() {
      if (this.emailFields.length < 5) {
        this.emailFields.push({
          mailAdress: ''
        });
      }
    },
    deleteEmailfield() {
      this.emailFields.pop();
    },
    addFiles() {
      this.$refs.selectedFiles.click();

    },
    removeFile(key) {
      this.selectedFiles.splice(key, 1);
    },
    submitFiles() {
      let formData = new FormData();
      formData.append('mutabakattoken', this.mutabakattoken);
      var time = moment().format('HH:mm') + " " + moment().format('YYYY-M-D');
      formData.append('time', time);

      if (this.userinfo == null) {
        this.userinfo = this.data.firmaunvan;
      }
      formData.append('userinfo', this.userinfo);


      this.percentCompleted = 0;

      for (var i = 0; i < this.selectedFiles.length; i++) {
        let file = this.selectedFiles[i];
        formData.append('fileData', file);
      }

      let that = this;
      var config = {
        onUploadProgress: function(progressEvent) {
          that.percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

        }
      };

      axios.post('/soagateway/api/reconcilation/addAttachment',
          formData, config, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function() {
          that.collapse2 = false;
          that.percentCompleted = 0;

          that.selectedFiles.forEach((f) => {
            var o = {
              time: time,
              userinfo: that.userinfo,
              dosyaadi: f.name
            }
            that.files.push(o)
          });

          console.log('SUCCESS!!');
        })
        .catch(function() {
          console.log('FAILURE!!');
        });


    },
    handleFilesUpload() {
      let uploadedFiles = this.$refs.selectedFiles.files;


      for (var i = 0; i < uploadedFiles.length; i++) {
        this.selectedFiles.push(uploadedFiles[i]);
      }
    },
    cikisYap() {
      localStorage.setItem("user-token", '');
      localStorage.setItem("user-info", '');
      this.$router.push({
        name: 'login',
        query: {
          redirect: '/'
        }
      });

    },
    dosyaUpdate(dosya) {
      this.files.push(this.dosya);
      this.filename = "";
      this.collapse2 = false;
      var dosyaad = dosya;




      let dosyaUploadData = {
        dosyaadi: dosyaad,
        mutabakattoken: this.mutabakattoken,
        userinfo: this.userinfo
      }

      axios.post('/soagateway/api/reconcilation/addAttachment', dosyaUploadData).then((response) => {}).catch((error) => {
        console.log(error);
        if (error.status == 500) {
          this.$bus.$emit('500error');
        }
      });
    },

    dosyaDownload(dosya) {
      var FileSaver = require('file-saver');
      let dosyaDownloadData = {
        dosyaadi: dosya,
        mutabakattoken: this.mutabakattoken
      }

      axios({
        method: 'post',
        url: '/soagateway/api/reconcilation/downloadAttachment',
        data: dosyaDownloadData,
        responseType: 'blob',
      }).then((response) => {
        console.log(response);
        var type = response.request.responseType;
        FileSaver.saveAs(new Blob([response.data]), dosya);
      }).catch((error) => {
        console.log(error);
        if (error.status == 500) {
          this.$bus.$emit('500error');
        }
      });
    },

    mesajyolla() {

      this.collapse = false;

      if (this.userinfo == null) {
        this.userinfo = this.data.firmaunvan;
      }

      let messageData = {
        message: this.messageText,
        mutabakattoken: this.mutabakattoken,
        time: moment().format('HH:mm') + " " + moment().format('YYYY-M-D'),
        userinfo: this.userinfo
      }
      this.messages.push(messageData);
      console.log(this.messages);

      axios.post('/soagateway/api/reconcilation/addComment', messageData).then((response) => {}).catch((error) => {
        console.log(error);
        if (error.response.status == 500) {
          this.$toastr('add', {
            msg: '500 error, Mesaj yollanamadı !',
            type: 'error'
          });
        }
      });
    },

    mutabyes() {
      this.editable = false;
      this.mutabakattext = "mutabık olduğumuzu";
    },

    mutabno() {
      this.editable = true;
      this.mutabButtonsVisible = false;
      this.mutabakattext = "mutabık olmadığımızı";
      this.onaytext = "Tablodan değişiklik yapabilirsiniz";
    },

    tableIptal() {
      this.data.belgeler.firmabelgesayi = "";
      this.data.belgeler.firmakdv = "";
      this.onaytext = "";
      this.editable = false;
      this.mutabButtonsVisible = true;
    },

    mutabOlmamaOnay() {
      let onaylanmamaData = {
        mutabakattoken: this.mutabakattoken,
        cevap: {
          status: "MTD",
          cevaptarih: moment().format('YYYY-M-D'),
          cevapsaat: moment().format('HH:mm'),
          ip: this.ip
        },
        belgeler: {
          firmabelgesayi: this.data.belgeler.firmabelgesayi,
          firmakdv: this.data.belgeler.firmakdv,
        },
      }

      axios.post('/soagateway/api/reconcilation/doReconcilation', onaylanmamaData).then((response) => {
        this.editable = false;
        this.mutabButtonsVisible = false;
        this.onaytext = "Mutabakat formu " + this.datenow + " tarihinde, " + this.timenow + " zamanında onaylanmadı. " + "ip: " + this.ip;
      }).catch((error) => {
        console.log(error);
        if (error.response.status == 500) {
          this.$toastr('add', {
            msg: '500 error, Mutabakat onay formu yollanamadı !',
            type: 'error'
          });
        }
      });


    },
    mutabOnay() {
      let onayData = {
        mutabakattoken: this.mutabakattoken,
        cevap: {
          status: "MTB",
          cevaptarih: moment().format('YYYY-M-D'),
          cevapsaat: moment().format('HH:mm'),
          ip: this.ip
        },
        belgeler: {
          firmabelgesayi: this.data.belgeler.firmabelgesayi,
          firmakdv: this.data.belgeler.firmakdv,
        },
      }

      axios.post('/soagateway/api/reconcilation/doReconcilation', onayData).then((response) => {
        this.mutabButtonsVisible = false;
        this.onaytext = "Mutabakat formu " + this.datenow + " tarihinde, " + this.timenow + " zamanında onaylandı. " + "ip: " + this.ip;
      }).catch((error) => {
        console.log(error);
        if (error.response.status == 500) {
          this.$toastr('add', {
            msg: '500 error, Mutabakat onay formu yollanamadı !',
            type: 'error'
          });
        }
      });



    },
    mutabakatAitDegil() {
      let data = {
        emailadresses: this.emailFields,
        incorrectfirmflag: this.mutabAitDegilCheckbox,
        mutabakattoken: this.mutabakattoken
      }


      axios.post('/soagateway/api/reconcilation/addExtraInformation', data).then((response) => {
        this.mutabButtonsVisible = false;
      }).catch((error) => {
        console.log(error);
        if (error.response.status == 500) {
          this.$toastr('add', {
            msg: '500 error, Mutabakat onay formu yollanamadı !',
            type: 'error'
          });
        }
      });

      console.log(data);

    }

  },
  created() {
    var that = this;

    var url_string = location.href;
    const url = new URL(url_string);
    url.searchParams.get('token_key');

    var tokenkey = url.searchParams.get("token_key");
    this.userinfo = localStorage.getItem("user-info");

    if (tokenkey == '') {
      this.$toastr('add', {
        msg: 'Mutabakat token alınamadı!',
        type: 'error'
      });
    }

    this.mutabakattoken = tokenkey;

    let token = {
      mutabakattoken: tokenkey
    }

    axios.post('/soagateway/api/reconcilation/getIpAddress', token).then((response) => {
      this.ip = response.data.ip;
      var x = this.ip;

      var res = x.split(".");


      if (res[0] === '192') {
        if (res[1] === '168') {
          var usertoken = localStorage.getItem("user-token");

          if (usertoken == null || usertoken == '') {
            this.$router.push({
              name: 'login',
              query: {
                redirect: '/'
              }
            });
          } else {
            that.usertoken = usertoken;
          }
        }
      }

      if (res[0] === '172') {
        if ('16' <= res[1] && res[1] <= '31') {
          var usertoken = localStorage.getItem("user-token");

          if (usertoken == null || usertoken == '') {
            this.$router.push({
              name: 'login',
              query: {
                redirect: '/'
              }
            });
          } else {
            that.usertoken = usertoken;
          }
        }
      }

      if (res[0] === '10') {
        var usertoken = localStorage.getItem("user-token");

        if (usertoken == null || usertoken == '') {
          this.$router.push({
            name: 'login',
            query: {
              redirect: '/'
            }
          });
        } else {
          that.usertoken = usertoken;
        }
      }



      // if (res[0] === '172' || res[0] === '192' || res[0] === '10') {
      //   var usertoken = localStorage.getItem("user-token");
      //
      //
      //   if (usertoken == null || usertoken == '') {
      //     this.$router.push({
      //       name: 'login',
      //       query: {
      //         redirect: '/'
      //       }
      //     });
      //   } else {
      //     that.usertoken = usertoken;
      //   }
      //
      // }

    }).catch((error) => {
      console.log(error);
      if (error.response.status == 500) {
        this.$toastr('add', {
          msg: '500 error, Ip adresi alınamadı !',
          type: 'error'
        });
      }
    });

    axios.post('/soagateway/api/reconcilation/getReconcilationData', token).then((response) => {
      this.data = response.data;
      this.files = response.data.files;
      this.messages = response.data.messages;
      this.loading = false;

    }).catch((error) => {
      console.log(error);
      if (error.response.status == 406) {
        this.loading = false;
        this.card406 = true;

      }
      if (error.response.status == 500) {
        this.loading = false;
        this.hata500 = true;
        this.$toastr('add', {
          msg: '500 error, Mutabakat formu alınamadı !',
          type: 'error'
        });
      }
    });

  }
}
</script>

<style>
p {
  font-size: 20px;
}

#cardbs {
  margin-top: 15px;
}

div.file-listing {
  width: 200px;
}

span.remove-file {
  color: red;
  cursor: pointer;
  float: right;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 15%;
}
</style>
